import Vue from 'vue'
import MediaThumb from 'objects/media/media-thumb'
import { truncateText } from 'util/text-utils'
import formatName from 'filters/format-name'
import { TYPE_PHOTO } from 'util/media-utils'

import withRender from './gallery-item.html'
import './gallery-item.scss'

export default withRender(Vue.extend({
  data() { return {} },
  props: {
    columnSpacing: {
      type: Number,
      default: 4
    },
    isHidden: {
      type: Boolean,
      default: true
    },
    mediaItem: { type: Object },
    mediaSize: {
      type: Number,
      default: 0
    },
    showCaption: {
      type: Boolean,
      default: false
    },
    truncateLength: {
      type: Number,
      default: 200
    }
  },
  components: { 'tt-media-thumb': MediaThumb },
  computed: {
    altText() {
      return this.$msg('media.submittedBy', [formatName(this.mediaItem.user)])
    },
    captionText() {
      if (this.truncatedText) {
        return this.truncatedText
      }
      return this.mediaItem.text ? this.mediaItem.text.trim() : ''
    },
    galleryItemStyles() {
      return `width:${this.mediaSize}px;margin-right:${this.columnSpacing}px`
    },
    linkTitle() {
      const username = formatName(this.mediaItem.user)
      const type = this.mediaItem.type === TYPE_PHOTO ? 'photo' : 'video'
      return this.$msg(`gallery.opensMediaModal.${type}`, [username])
    },
    tabIndex() {
      return this.isHidden ? '-1' : '0'
    },
    truncatedText() {
      const caption = this.mediaItem.text ? this.mediaItem.text.trim() : ''
      if (caption) {
        return truncateText(caption, this.truncateLength, 9)
      }
      return ''
    }
  }
}))
